import React, { useState, useEffect } from 'react';
import './ContactUs.css';
import { supabase } from '../config/supabase';

const ContactUs = () => {

    // CMS CONTENT STATE
    const [pageContent, setPageContent] = useState({
        hero: {
            title: 'Ready to Connect',
            subtitle: "We're here to support your career growth and your organization's operational needs.",
            bgImage: 'https://images.unsplash.com/photo-1423666639041-f56000c27a9a?auto=format&fit=crop&q=80'
        },
        info: {
            email: 'Info@pharmaempower.com',
            phone: '+1 (555) 123-4567',
            address: '123 Pharma Way, Innovation City, PC 54321'
        }
    });

    // FETCH CMS CONTENT FROM SUPABASE
    useEffect(() => {
        const fetchPageContent = async () => {
            try {
                const { data, error } = await supabase
                    .from('pages')
                    .select('content')
                    .eq('slug', 'contact')
                    .single();
                
                if (data?.content) {
                    setPageContent(prev => ({
                        hero: { ...prev.hero, ...data.content.hero },
                        info: { ...prev.info, ...data.content.info }
                    }));
                }
            } catch (err) {
                console.warn('CMS Contact page not found, using defaults');
            }
        };
        fetchPageContent();
    }, []);

    // CONTACT FORM STATE
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
        organizationalNeed: ''
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // Submit directly to Supabase - admin will see it in real-time
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess(false);
        setLoading(true);

        try {
            const { error: insertError } = await supabase
                .from('contact_messages')
                .insert([{
                    name: formData.name,
                    email: formData.email,
                    subject: formData.subject,
                    organization_need: formData.organizationalNeed,
                    message: formData.message,
                    status: 'New'
                }]);

            if (insertError) throw insertError;

            setSuccess(true);
            setFormData({ name: '', email: '', subject: '', message: '', organizationalNeed: '' });
            setTimeout(() => setSuccess(false), 6000);

        } catch (err) {
            setError(err.message || 'Failed to send message. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="contact-container">

            <div
                className="contact-header"
                style={{
                    backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${pageContent.hero.bgImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    color: 'white',
                    padding: '4rem 2rem'
                }}
            >
                <h1>{pageContent.hero.title}</h1>
                <p>{pageContent.hero.subtitle}</p>
            </div>

            <div className="contact-info-bar" style={{ textAlign: 'center', padding: '2rem 0', background: '#f7fafc' }}>
                <p>
                    <strong>Email:</strong> {pageContent.info.email}
                    &nbsp;|&nbsp;
                    <strong>Phone:</strong> {pageContent.info.phone}
                </p>
                <p><strong>Address:</strong> {pageContent.info.address}</p>
            </div>

            <div className="contact-form-wrapper">
                <form className="contact-form" onSubmit={handleSubmit}>

                    {success && (
                        <div style={{ background: '#d4edda', color: '#155724', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', border: '1px solid #c3e6cb', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            ✅ Thank you! Your message has been sent. We'll get back to you soon.
                        </div>
                    )}

                    {error && <p className="error-text" style={{ color: '#c62828', marginBottom: '12px' }}>{error}</p>}

                    <div className="form-group">
                        <label>Name *</label>
                        <input type="text" name="name" value={formData.name} onChange={handleChange} required />
                    </div>

                    <div className="form-group">
                        <label>Email *</label>
                        <input type="email" name="email" value={formData.email} onChange={handleChange} required />
                    </div>

                    <div className="form-group">
                        <label>Subject *</label>
                        <input type="text" name="subject" value={formData.subject} onChange={handleChange} required />
                    </div>

                    <div className="form-group">
                        <label>Organizational Need (Optional)</label>
                        <input
                            type="text"
                            name="organizationalNeed"
                            value={formData.organizationalNeed}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group">
                        <label>Message *</label>
                        <textarea
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                            rows="5"
                        />
                    </div>

                    <button type="submit" className="submit-btn" disabled={loading}>
                        {loading ? 'Sending...' : 'Send Message'}
                    </button>

                </form>
            </div>
        </div>
    );
};

export default ContactUs;
